import Templates from './Templates.vue'
import MenuItem from "./../../../core/components/menu/MenuItem";
import i18n from '../../../shared/i18n'

let routes = [{
  path: 'templates',
  name: 'templates',
  component: Templates,
  meta: {
    requiresAuth: true
  }
}];

export default {
  menuItem: new MenuItem('/templates', i18n.t('Templates'), 40, 'mail-bulk'),
  routes: routes
}
